<div class="container" >
  <h1 class="fs-2 fw-light mt-4">List of Breaches</h1>

  <div class="form-group my-4">
      <label class="form-label" for="propertyname">Property Name</label>
      <input class="form-control col-3"  type="text" [value]="propertyName" readonly/>
  </div>


  <div class="form-group my-4">
  <label class="form-label" for="propertyname">APT/LOT #</label>
  <input class="form-control col-3"  type="text" [value]="unitNumberLabel" readonly/>
  </div>

  <table class="table table-striped table-bordered">
      <thead class="py-1">
        <th scope="col">Title</th>
        <th scope="col">Description</th>
        <th scope="col">Date Recorded</th>
        <th scope="col">Last Updated</th>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td colspan="4">Loading breaches...</td>
          </tr>
        }

        @if (!loading && breaches.length == 0) {
          <tr>
            <td colspan="4">No data found!</td>
          </tr>
        }

        @for (breach of breaches; track breach.id) {
          <tr>
            <td>{{ breach.title }}</td>
            <td>{{ breach.description }}</td>
            <td>{{ breach.datereported | date: 'MMM d, y' }}</td>
            <td>{{ breach.updatedAt ? (breach.updatedAt | date: 'MMM d, y, h:mm a') : 'N/A' }}</td>
          </tr>
        }
      </tbody>

    </table>
    <div class="mt-4">
      <button (click)="goBack()" class="btn btn-primary d-print-none"><fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back</button>
      <button (click)="goHome()" class="btn btn-info float-end d-print-none"><fa-icon [icon]="faHomeAlt"></fa-icon> Home</button>
    </div>
</div>
